
import { GameHeader } from "../GameHeader";
import { Button } from "@/components/ui/button";
import { Clock } from "lucide-react";
import { useState, useEffect } from "react";
import { getTimeUntilNextPuzzle } from "@/utils/dateUtils";

interface PostGamePlayViewProps {
  onViewResults: () => void;
}

export function PostGamePlayView({ onViewResults }: PostGamePlayViewProps) {
  const [nextPuzzleTime, setNextPuzzleTime] = useState<string>("");
  
  useEffect(() => {
    const updateCountdown = () => {
      const { hours, minutes } = getTimeUntilNextPuzzle();
      
      if (hours === 0 && minutes === 0) {
        setNextPuzzleTime("Available now!");
        return;
      }
      
      setNextPuzzleTime(`${hours}h ${minutes}m`);
    };

    // Run once immediately
    updateCountdown();
    
    // Set an interval to update every minute
    const interval = setInterval(updateCountdown, 60000);
    
    // Clean up interval on unmount
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="h-full w-full min-w-[320px] flex flex-col items-center py-2">
      <div className="container mx-auto px-4 py-4 flex flex-col items-center">
        <GameHeader />
      </div>
        
      <div className="w-full animate-fade-in px-4 flex flex-col items-center justify-center">
        {/* Next puzzle countdown */}
        <div className="text-sm text-gray-500 mb-4 flex items-center gap-2">
          <Clock className="h-3 w-3" />
          <span>Next puzzle in {nextPuzzleTime}</span>
        </div>
        
        {/* Today's Results Button - Made taller to match Start Game button */}
        <button
          onClick={onViewResults}
          className="w-full max-w-md px-4 py-4 bg-gray-100 text-black border border-gray-200 rounded-lg font-medium hover:bg-gray-200 transition-colors flex items-center justify-center gap-2 mb-4"
          type="button"
        >
          View Today's Results
        </button>
        
        <div className="text-center text-gray-500 text-sm mt-6">
          <p className="mb-0.5">Created by:</p>
          <a href="https://matchmylogic.com" target="_blank" rel="noopener noreferrer" className="text-gray-600 hover:text-gray-800 underline">
            matchmylogic.com
          </a>
        </div>
      </div>
    </div>
  );
}
